import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Router } from '@angular/router';
import { webConfig } from '../../webConfig';
import { Helpers } from '../../helpers';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class AuthenticationService {

    constructor(private http: Http, private config: webConfig) { }
    login(email: string, password: string) {
        let url = this.config.url + 'auth/jwt/create/';
        let headers = new Headers({ 'Content-Type': 'application/json' });
        const options = new RequestOptions({ headers: headers });
        return this.http.post(url, { email: email, password: password }, options)
            .map(
            (res: Response) => {
                if (res) {
                    if (res.status === 201) {
                        return res.json()
                    }
                    else if (res.status === 200) {
                        return res.json()
                    }
                    else if (res.status === 202) {
                        return res.json()
                    }
                }
            }).catch((error: any) => {
                if (error.status === 500) {
                    return Observable.throw(new Error(error.status));
                }
                else if (error.status === 400) {
                    return Observable.throw(new Error(error.status));
                } else if (error.status === 409) {
                    return Observable.throw(new Error(error.status));
                }
                else if (error.status === 406) {
                    return Observable.throw(new Error(error.status));
                }
                Helpers.setLoading(false);

            });
    }


    forgot(email: string) {
        let url = this.config.url + 'auth/password/reset/';
        let headers = new Headers({ 'Content-Type': 'application/json' });
        const options = new RequestOptions({ headers: headers });
        return this.http.post(url, { email: email }, options)
            .map(
            (res: Response) => {
                if (res) {
                    if (res.status === 201) {
                        return res.json()
                    }
                    else if (res.status === 200) {
                        return res.json()
                    }
                    else if (res.status === 202) {
                        return res.json()
                    }
                }
            }).catch((error: any) => {
                if (error.status === 500) {
                    return Observable.throw(new Error(error.status));
                }
                else if (error.status === 400) {
                    return Observable.throw(new Error(error.status));
                } else if (error.status === 409) {
                    return Observable.throw(new Error(error.status));
                }
                else if (error.status === 406) {
                    return Observable.throw(new Error(error.status));
                }
                Helpers.setLoading(false);

            });
    }

    isAuth() {
        const user = localStorage.getItem('currentUser');
        return !!user;
    }
    logout() {
        localStorage.removeItem('currentUser');
    }
}


// WEBPACK FOOTER //
// D:/FMFB/FMFB Dashboard/src/app/auth/_services/authentication.service.ts